import { handleActions } from 'redux-actions'
import { setSelectedUserId, resetFormsState } from '../actions'

const defaultValue: number = 0

const selectedUserId = handleActions(
  {
    [setSelectedUserId.toString()](state, action) {
      return action.payload
    },
    [resetFormsState.toString()](state, action) {
      return defaultValue
    },
  },
  defaultValue
)

export default selectedUserId
